<template>
  <div>
    <d-button-group class="buttons">
      <d-button size="sm" class="btn-danger" @click.prevent="confirmDeleteRow()">
        <i class="fas fa-trash"></i>
        <span class="d-none d-lg-inline"> Deletar</span>
      </d-button>
    </d-button-group>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';

export default {
  name: 'DeleteButton',
  props: {
    itemId: {
      type: [String, Number],
      required: true,
    },
    deleteEvent: {
      type: String,
      required: true,
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    confirmDeleteRow() {
      this.setToggle({ type: 'confirm_modal', bool: true });
      Events.$emit(this.deleteEvent, this.itemId);
    },
  },
};
</script>
